import React from "react";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";
import SurveyResultsFilter from "./survey-results-filter";
import SurveyResultsResponses from "./survey-results-responses";
import ReactMarkdown from "react-markdown";
import * as H from "../helpers/index";
import * as Chart from "recharts";
import { Button, Box } from "@material-ui/core";

const SurveyResults = ({ store }) => {
  const { $survey, $user, $locale, $question, $group, $alert, $router } = store;

  console.log("re", $survey.selected.responsesForSelectedGroup);

  return (
    $survey.selected &&
    ($user.sessionUser.isMentor ? (
      <React.Fragment>
        {/* Title + print */}
        <div className="flex justify-between hide-for-print mb-8">
          <h3>Resultaten</h3>
          <div className="flex items-center">
            <Box marginRight={2}>
              <Button onClick={() => $survey.selected.resultsToXls()}>Export (XLS)</Button>
            </Box>
            <Icon.Printer className="pointer" onClick={() => window.print()} />
          </div>
        </div>

        {/* filters */}
        {$user.sessionUser.isVerifiedMentor && $group.list.size && <SurveyResultsFilter />}

        {!$user.sessionUser.isVerifiedCreator && (
          <ReactMarkdown className="mt-4" source={$locale.t($survey.selected._key + "_feedback")} />
        )}

        {$alert.list.size ? (
          <div className="mt-4">LOADING</div>
        ) : (
          <React.Fragment>
            {
              /* no results */
              $user.sessionUser.isMentor && !$survey.selected.responsesForSelectedGroup.length && (
                <div className="bg-orange p-4 border-radius color-white mb-4">
                  Geen resultaten gevonden.
                </div>
              )
            }

            {
              /* results */
              !!$survey.selected.responsesForSelectedGroup.length && (
                <div className="mt-8 question-result-list">
                  {$survey.selected.questionTree.map((question, index) => {
                    question = $question.list.get(question._key);
                    return <RenderQuestion key={question._key} question={question} index={index} />;
                  })}
                </div>
              )
            }

            {/* responses list */}
            {$user.sessionUser.isAdmin && <SurveyResultsResponses />}
          </React.Fragment>
        )}
      </React.Fragment>
    ) : (
      <div>
        <div>
          {$locale.t($survey.selected._key + "_feedback") ||
            "Bedankt om deze vragenlijst in te vullen. Wij hebben uw gegevens goed ontvangen."}
        </div>

        {$router.getURLParameterByName("mentor") === "true" && (
          <div className="mt-4">
            <Button
              onClick={() =>
                $router.push(
                  "/survey/view/" +
                    $router.id +
                    "/?group=" +
                    $router.getURLParameterByName("group") +
                    "&mentor=" +
                    $router.getURLParameterByName("mentor")
                )
              }
            >
              Opnieuw invullen
            </Button>
          </div>
        )}
      </div>
    ))
  );
};

const colors = ["#007DB3", "#00B2FF", "#0086BF", "#005073", "#006B99"];

const RenderQuestion = inject("store")(
  observer(({ question, store, index }) => (
    <React.Fragment>
      {!!(question.type === "fieldset" || question.type === "legend") && (
        <div
          id={question._key}
          className={`question-result-fieldset ${
            question.type === "fieldset" && index ? "break-inside-avoid" : ""
          }`}
        >
          {question.type === "fieldset" ? (
            <h3 style={{ marginBottom: "1.5rem" }}>{store.$locale.t(question._key)}</h3>
          ) : (
            <h4 style={{ marginBottom: "1.5rem" }}>{store.$locale.t(question._key)}</h4>
          )}
          {question.children.some(child => child.type.indexOf("scale") > -1) && (
            <div
              className="bg-white mb-8 flex flex-col justify-center items-center"
              style={{ marginLeft: "-1.5rem", marginRight: "-1.5rem" }}
            >
              <PieChartForFieldset
                question={question}
                groupKey={store.$group.selected && store.$group.selected._key}
                store={store}
              />
            </div>
          )}
          <div>
            {!!question &&
              ((question.locale &&
                question.locale[store.$locale.activeLocale] &&
                question.locale[store.$locale.activeLocale].feedback) ||
                store.$locale.t(question._key + "_feedback")) && (
                <ShowHideTipsButton onToggle={question.toggleShowTips} parent={question} />
              )}
            {question.showTips && (
              <ReactMarkdown
                source={
                  question &&
                  ((question.locale &&
                    question.locale[store.$locale.activeLocale] &&
                    question.locale[store.$locale.activeLocale].feedback) ||
                    store.$locale.t(question._key + "_feedback"))
                }
                className="mt-4"
              />
            )}
          </div>
          {!!question.children.some(child => child.type.indexOf("scale") > -1) && (
            <ShowHideQuestionButton onToggle={question.toggleShowChildren} parent={question} />
          )}
          {question.children.sort(H.compare("order", "asc")).map((child, index) => (
            <RenderQuestion key={index} question={child} index={index} />
          ))}
        </div>
      )}

      {question.parentKey && store.$question.list.get(question.parentKey).showChildren && (
        <React.Fragment>
          {!!(question.type === "list") && (
            <div
              id={question._key}
              className={`mb-4 bg-white p-3 flex justify-center items-center flex-col border-for-print question-result-list break-inside-avoid `}
            >
              <h4>{store.$locale.t(question._key)}</h4>
              <ReactMarkdown
                source={
                  question &&
                  ((question.locale &&
                    question.locale[store.$locale.activeLocale] &&
                    question.locale[store.$locale.activeLocale].feedback) ||
                    store.$locale.t(question._key + "_feedback"))
                }
                className="mt-4"
              />

              <BarChartVertical
                question={question}
                groupKey={store.$group.selected && store.$group.selected._key}
                store={store}
              />
            </div>
          )}

          {!!(question.type === "boolean") && (
            <div
              id={question._key}
              className={
                "mb-4 bg-white p-6 flex justify-center items-center flex-col border-for-print break-inside-avoid"
              }
            >
              <h4 className="mb0">{store.$locale.t(question._key)}</h4>
              <ReactMarkdown
                source={
                  question &&
                  ((question.locale &&
                    question.locale[store.$locale.activeLocale] &&
                    question.locale[store.$locale.activeLocale].feedback) ||
                    store.$locale.t(question._key + "_feedback"))
                }
                className="mt-4"
              />
              <BarChartVertical
                question={question}
                groupKey={store.$group.selected && store.$group.selected._key}
                store={store}
              />
            </div>
          )}

          {!!(question.type === "text") && (
            <div
              id={question._key}
              className={
                "mb-4 bg-white p-6 flex justify-center items-center flex-col border-for-print question-result-text break-inside-avoid"
              }
            >
              <h4 className="mb-4">{store.$locale.t(question._key)}</h4>
              {store.$group.selected && (
                <div>
                  {!question.getAnswerValuesForGroup(store.$group.selected._key).length ? (
                    <div>Geen resultaten gevonden</div>
                  ) : (
                    question
                      .getAnswerValuesForGroup(store.$group.selected._key)
                      .map((answer, i) => (
                        <div className={"mb-4 bg-gray-lightest p2"}>"{answer}"</div>
                      ))
                  )}
                </div>
              )}
            </div>
          )}

          {!!(question.type === "scale" || question.type === "scale_custom") && (
            <div
              id={question._key}
              className={
                "mb-4 bg-white p-6 flex justify-center items-center flex-col border-for-print question-result-scale break-inside-avoid "
              }
            >
              <h4 className="mb0">{store.$locale.t(question._key)}</h4>
              <ReactMarkdown
                source={
                  question &&
                  ((question.locale &&
                    question.locale[store.$locale.activeLocale] &&
                    question.locale[store.$locale.activeLocale].feedback) ||
                    store.$locale.t(question._key + "_feedback"))
                }
                className="mt-4"
              />
              {(store.$survey.selected._key === "duPk9ttEIdVC2JfxLW0u" ||
                store.$survey.selected._key === "B8MMEEdLT3kqs5POdBZ1" ||
                store.$survey.selected._key === "MDzzBP4QmI0uzudScsSt" ||
                store.$survey.selected._key === "QgXZUTpkJ93O2tk7Tb7S" ||
                store.$survey.selected._key === "sJVy160eMJxrqswhwyNC" ||
                store.$survey.selected._key === "oJty9S94edst7NF0oIrY" ||
                store.$survey.selected._key === "GZORbNC6q49tR95Oi2Db" ||
                store.$survey.selected._key === "BQqnRj7nJ7WvBQYmO1SF") &&
              !question.createdForGroup ? (
                <BarChartVerticalStacked
                  question={question}
                  groupKey={store.$group.selected && store.$group.selected._key}
                  store={store}
                />
              ) : (
                <BarChartVertical
                  question={question}
                  groupKey={store.$group.selected && store.$group.selected._key}
                  store={store}
                />
              )}
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  ))
);

const PieChartForFieldset = ({ question, groupKey, store }) => {
  let data = [];

  if (!question.children.length) return <div>no children</div>;

  const options =
    question.children[0].type === "scale"
      ? store.$config.field_types.find(type => type.value === "scale").options
      : question.children[0].typeOptions.toJSON();

  let answerValues = question.getAnswerValuesForGroup(groupKey);
  answerValues = answerValues.filter(v => options.find(o => String(o.value) === v));

  data = options.map((option, i) => {
    let dataObject = {
      name: option.label || option.value,
      color: option.color || colors[i]
    };
    let value = Math.round(
      (answerValues.filter(v => v === String(option.value)).length / answerValues.length) * 100
    );
    dataObject.value = value;
    return dataObject;
  });

  return (
    <Chart.PieChart width={600} height={250}>
      <Chart.Pie
        isAnimationActive={false}
        dataKey="value"
        startAngle={180}
        endAngle={0}
        data={data}
        cx={175}
        cy={175}
        outerRadius={100}
        label={e => Math.abs(e.value) + "%"}
      >
        {data.map((entry, index) => (
          <Chart.Cell key={"slice" + index} fill={entry.color} />
        ))}
      </Chart.Pie>
      <Chart.Legend
        layout="vertical"
        verticalAlign="middle"
        wrapperStyle={{ left: 375, fontSize: "13px" }}
      />
    </Chart.PieChart>
  );
};

const BarChartVerticalStacked = ({ question, groupKey, store }) => {
  let data = [];

  const responses = question.getResponses(false, groupKey);
  const options =
    question.type === "scale"
      ? store.$config.field_types.find(type => type.value === "scale").options
      : question.typeOptions;

  const calculateAverages = function (dataObject, values) {
    options.forEach(option => {
      dataObject[option.key || option.value] =
        (values.filter(v => v === String(option.value)).length / values.length) * 100;
    });
    return dataObject;
  };

  //global
  const answerValues = question.getAnswerValuesForGroup(groupKey);

  if (
    (store.$survey.selected._key === "oJty9S94edst7NF0oIrY" ||
      store.$survey.selected._key === "QgXZUTpkJ93O2tk7Tb7S" ||
      store.$survey.selected._key === "GZORbNC6q49tR95Oi2Db" ||
      store.$survey.selected._key === "BQqnRj7nJ7WvBQYmO1SF" ||
      store.$survey.selected._key === "B8MMEEdLT3kqs5POdBZ1" ||
      store.$survey.selected._key === "duPk9ttEIdVC2JfxLW0u" ||
      store.$survey.selected._key === "MDzzBP4QmI0uzudScsSt" ||
      store.$survey.selected._key === "sJVy160eMJxrqswhwyNC") &&
    !question.createdForGroup
  ) {
    data.push(calculateAverages({ name: "Algemeen" }, answerValues));
    let languageKey;
    if (store.$survey.selected._key === "B8MMEEdLT3kqs5POdBZ1")
      languageKey = "OwWs5GOw3GlMVjb8EcqU";
    if (store.$survey.selected._key === "duPk9ttEIdVC2JfxLW0u")
      languageKey = "Job1efZ6cqgPU62N1cIh";
    if (store.$survey.selected._key === "MDzzBP4QmI0uzudScsSt")
      languageKey = "GNRs60kYARaUbKtGh4jL";
    if (store.$survey.selected._key === "oJty9S94edst7NF0oIrY")
      languageKey = "GNRs60kYARaUbKtGh4jL";
    if (store.$survey.selected._key === "QgXZUTpkJ93O2tk7Tb7S")
      languageKey = "GNRs60kYARaUbKtGh4jL";
    if (store.$survey.selected._key === "GZORbNC6q49tR95Oi2Db")
      languageKey = "GNRs60kYARaUbKtGh4jL";
    if (store.$survey.selected._key === "BQqnRj7nJ7WvBQYmO1SF")
      languageKey = "GNRs60kYARaUbKtGh4jL";
    if (store.$survey.selected._key === "sJVy160eMJxrqswhwyNC")
      languageKey = "GNRs60kYARaUbKtGh4jL";

    let educationKey;
    if (store.$survey.selected._key === "B8MMEEdLT3kqs5POdBZ1")
      educationKey = "ProFxDZ4szUrLXcmlIPA";
    if (store.$survey.selected._key === "duPk9ttEIdVC2JfxLW0u")
      educationKey = "ba15Mz4C8wFqkXSI0093";
    if (store.$survey.selected._key === "MDzzBP4QmI0uzudScsSt")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";
    if (store.$survey.selected._key === "oJty9S94edst7NF0oIrY")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";
    if (store.$survey.selected._key === "QgXZUTpkJ93O2tk7Tb7S")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";
    if (store.$survey.selected._key === "GZORbNC6q49tR95Oi2Db")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";
    if (store.$survey.selected._key === "BQqnRj7nJ7WvBQYmO1SF")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";
    if (store.$survey.selected._key === "sJVy160eMJxrqswhwyNC")
      educationKey = "Zn1zQlvIE6evvRmSTpSB";

    //language dutch
    const answerValuesLanguageDutch = [].concat.apply(
      [],
      responses
        .filter(r => r.answers[languageKey] === "nederlands")
        .map(r => r.answers[question._key])
        .filter(value => value)
    );
    data.push(calculateAverages({ name: "Nederlands" }, answerValuesLanguageDutch));

    //language other
    const answerValuesLanguageOther = [].concat.apply(
      [],
      responses
        .filter(r => r.answers[languageKey] !== "nederlands")
        .map(r => r.answers[question._key])
        .filter(value => value)
    );
    data.push(calculateAverages({ name: "Anderstalig" }, answerValuesLanguageOther));

    //education low
    const answerValuesEducationLow = [].concat.apply(
      [],
      responses
        .filter(r =>
          ["geen-onderwijs", "lager-onderwijs-tot-ongeveer-12-jaar"].includes(
            r.answers[educationKey]
          )
        )
        .map(r => r.answers[question._key])
        .filter(value => value)
    );

    data.push(calculateAverages({ name: "Laaggeschoold" }, answerValuesEducationLow));

    //education mid
    const answerValuesEducationMid = [].concat.apply(
      [],
      responses
        .filter(r => ["secundair-onderwijs"].includes(r.answers[educationKey]))
        .map(r => r.answers[question._key])
        .filter(value => value)
    );

    data.push(calculateAverages({ name: "Midden" }, answerValuesEducationMid));

    //education high
    const answerValuesEducationHigh = [].concat.apply(
      [],
      responses
        .filter(r =>
          ["hogeschool-bachelor", "universiteit-master"].includes(r.answers[educationKey])
        )
        .map(r => r.answers[question._key])
        .filter(value => value)
    );

    data.push(calculateAverages({ name: "Hooggeschoold" }, answerValuesEducationHigh));
  } else {
    data.push(calculateAverages({ name: "" }, answerValues));
  }

  return (
    <div className="w-100">
      <Chart.BarChart
        layout="vertical"
        width={625}
        height={100 + data.length * 25}
        data={data}
        margin={{ top: 15, right: 30, bottom: 15, left: 30 }}
        stackOffset="expand"
      >
        <Chart.YAxis
          dataKey="name"
          type="category"
          hide={false}
          tick={{ fontSize: 12 }}
          width={100}
          interval="preserveStart"
        />
        <Chart.XAxis
          type="number"
          tick={{ fontSize: 12 }}
          tickFormatter={(decimal, fixed = 0) => `${(decimal * 100).toFixed(fixed)}%`}
        />
        {options.map((option, i) => (
          <Chart.Bar
            key={option.key || option.value}
            dataKey={option.key || option.value}
            stackId="a"
            barSize={20}
            fill={option.key ? options.find(o => o.key === option.key).color : colors[i]}
            isAnimationActive={false}
          />
        ))}
      </Chart.BarChart>
      <div className="flex justify-between ">
        <div className="w-2/12"></div>
        {options.map((option, i) => (
          <div
            key={"option" + i}
            className="flex justify-end items-center font-size-small text-right w-2/12"
          >
            {option.symbol || option.label || option.value}
            <div
              className="ml-1 text-right"
              style={{
                backgroundColor: option.color || colors[i],
                width: "14px",
                height: "10px"
              }}
            ></div>
          </div>
        ))}
      </div>
      <div className="font-size-small">
        {data.map((category, i) => (
          <div key={"category" + i} className="flex justify-between">
            <div className="w-2/12">{category.name}</div>
            {Object.keys(category).map((key, i) => {
              return (
                options.map(o => o.key || o.value).includes(key) && (
                  <div key={"option" + i} className="text-right w-2/12">
                    {Math.floor(category[key])} %
                  </div>
                )
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

const BarChartVertical = ({ question, groupKey, store }) => {
  let data = [];
  let options = [];
  const answerValues = question.getAnswerValuesForGroup(groupKey);

  if (question.type === "boolean") {
    data.push({ name: "nee", color: "red", value: 0 });
    data.push({ name: "ja", color: "green", value: 0 });

    options = data;

    answerValues.forEach(value => {
      data.forEach(option => {
        if (option.name === value) {
          option.value++;
        }
      });
    });

    data[0].value = Math.round((data[0].value / answerValues.length) * 100);
    data[1].value = Math.round((data[1].value / answerValues.length) * 100);
  } else {
    options =
      question.type === "scale"
        ? store.$config.field_types.find(type => type.value === "scale").options
        : question.typeOptions.toJSON();

    data = options.map((option, i) => {
      const dataObject = {};
      dataObject.key = option.value;
      dataObject.color = option.color || colors[0];
      dataObject.name =
        (question.translatedTypeOptions[i] && question.translatedTypeOptions[i].label) ||
        store.$locale.t(question._key + "_option" + i) ||
        option.label;
      dataObject.value = Math.round(
        (answerValues.filter(v => v === String(option.value)).length / answerValues.length) * 100
      );
      return dataObject;
    });
  }

  return (
    <Chart.BarChart
      width={650}
      height={options.length * 45}
      data={data}
      layout="vertical"
      margin={{ top: 15, right: 30, bottom: 15, left: 30 }}
    >
      <Chart.YAxis type="category" dataKey="name" interval={0} width={150} fontSize="12px" />
      <Chart.XAxis type="number" tickFormatter={value => value + " %"} hide fontSize="13px" />
      <Chart.Bar
        dataKey="value"
        fill="#007db3"
        barSize={10}
        isAnimationActive={false}
        label={<BarChartVerticalLabel />}
      >
        {data.map((entry, index) => {
          return <Chart.Cell key={"cell" + index} fill={data[index].color} />;
        })}
      </Chart.Bar>
    </Chart.BarChart>
  );
};

const BarChartVerticalLabel = ({ x, y, fill, value }) => (
  <text
    x={x + 6}
    y={Math.round(y - 7)}
    fontSize="12"
    fontFamily="sans-serif"
    fill={fill}
    color={fill}
    textAnchor="start"
  >
    {value} %
  </text>
);

const ShowHideQuestionButton = observer(({ parent, onToggle }) => (
  <Box displayPrint="none" marginBottom={2}>
    <Button
      startIcon={parent._showChildren ? <Icon.ArrowUp /> : <Icon.ArrowDown />}
      onClick={() => onToggle(parent._key)}
    >
      {parent._showChildren ? "Verberg vragenlijst" : "Toon resultaat per vraag"}
    </Button>
  </Box>
));

const ShowHideTipsButton = ({ parent, onToggle }) => (
  <Box displayPrint="none" marginBottom={2}>
    <Button
      startIcon={parent._showTips ? <Icon.ArrowUp /> : <Icon.ArrowDown />}
      onClick={() => onToggle(parent._key)}
    >
      {parent._showTips ? "Verberg Tips" : "Tips"}
    </Button>
  </Box>
);

// const PieChartForBoolean = ({ question, groupKey, store }) => {
//   let data = [];
//   const answerValues = question.getAnswerValuesForGroup(groupKey);
//   data.push({ name: "nee", color: "red", value: 0 });
//   data.push({ name: "ja", color: "green", value: 0 });
//   answerValues.forEach(value => {
//     data.forEach(option => {
//       if (option.name === value) {
//         option.value++;
//       }
//     });
//   });

//   data[0].value = Math.round((data[0].value / answerValues.length) * 100);
//   data[1].value = Math.round((data[1].value / answerValues.length) * 100);

//   return (
//     <Chart.PieChart width={600} height={150}>
//       <Chart.Pie
//         isAnimationActive={false}
//         dataKey="value"
//         startAngle={180}
//         endAngle={0}
//         data={data}
//         cx={175}
//         cy={125}
//         outerRadius={100}
//         label={e => Math.abs(e.value) + "%"}
//       >
//         {data.map((entry, index) => (
//           <Chart.Cell key={"slice" + index} fill={entry.color} />
//         ))}
//       </Chart.Pie>
//       <Chart.Legend layout="vertical" verticalAlign="middle" wrapperStyle={{ left: 375 }} />
//     </Chart.PieChart>
//   );
// };

export default inject("store")(observer(SurveyResults));
